// import { CommonResponse } from "@boi/shared-models";
// import { AxiosRequestConfig } from "axios";
// import { CommonAxiosService } from "../common-axios-service";

// interface TranslateReqModel {
//     text: string;
// }

// export class TranslationService extends CommonAxiosService {

//     private getURLwithMainEndPoint(childUrl: string) {
//         return '/translation/' + childUrl;
//     }

//     async translateToHindi(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
//         return await this.axiosPostCall(
//             this.getURLwithMainEndPoint('translate-to-hindi'),
//             req,
//             config
//         );
//     }

//     async healthCheck(config?: AxiosRequestConfig): Promise<CommonResponse> {
//         return await this.axiosGetCall(
//             this.getURLwithMainEndPoint('health'),
//             config
//         );
//     }
// }










// import { CommonResponse } from "@boi/shared-models";
import { AxiosRequestConfig } from "axios";
import { CommonAxiosService } from "../common-axios-service";
import { CommonResponse } from "@boi/shared-models";

export interface TranslateReqModel {
    text: string;
}

export interface TranslateBatchReqModel {
    texts: string[];
    targetLanguage: string;
}

export interface MultiLanguageTranslateReqModel {
    text: string;
    targetLanguages: string[];
}

export class TranslationService extends CommonAxiosService {

    private getURLwithMainEndPoint(childUrl: string) {
        return '/translation/' + childUrl;
    }

    // Single language translations
    async translateToHindi(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-hindi'),
            req,
            config
        );
    }

    async translateToTelugu(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-telugu'),
            req,
            config
        );
    }

    async translateToTamil(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-tamil'),
            req,
            config
        );
    }

    async translateToBengali(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-bengali'),
            req,
            config
        );
    }

    async translateToMarathi(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-marathi'),
            req,
            config
        );
    }

    async translateToGujarati(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-gujarati'),
            req,
            config
        );
    }

    async translateToKannada(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-kannada'),
            req,
            config
        );
    }

    async translateToMalayalam(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-malayalam'),
            req,
            config
        );
    }

    async translateToPunjabi(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-punjabi'),
            req,
            config
        );
    }

    async translateToOdia(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-odia'),
            req,
            config
        );
    }

    async translateToUrdu(req: TranslateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-to-urdu'),
            req,
            config
        );
    }

    // Generic translate endpoint
    async translate(req: { text: string; targetLanguage: string }, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate'),
            req,
            config
        );
    }

    // Batch translation for single language
    async translateBatch(req: TranslateBatchReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(
            this.getURLwithMainEndPoint('translate-batch'),
            req,
            config
        );
    }

    // Get supported languages
    async getSupportedLanguages(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosGetCall(
            this.getURLwithMainEndPoint('languages'),
            config
        );
    }

    async healthCheck(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosGetCall(
            this.getURLwithMainEndPoint('health'),
            config
        );
    }
}